import React from 'react';
import { Form } from 'tea-component';
import type { IBaseProps } from '@/pages/intelligence/types/common';

interface IOption {
  label: string;
  value: string;
  [key: string]: any;
}

interface IAutoFormControlTextProps extends IBaseProps {
  // 控件option选项
  options?: IOption[];
  // 控件渲染方法
  formControlRenderer?: () => React.ReactElement;
  translater?: any;
  [key: string]: any;
}

export default function AutoFormControlText(props: IAutoFormControlTextProps) {
  const { options, formControlRenderer, translater } = props;

  const isOnlyOneOption = Array.isArray(options) && options?.length === 1;

  return (
    <>
      {/* 一个option时，按照文本形式渲染 */}
      {isOnlyOneOption && <Form.Text>{translater?.({ id: options?.[0]?.label })}</Form.Text>}
      {/* 多个options时，按照外面传入的控件形式渲染 */}
      {isOnlyOneOption || formControlRenderer?.()}
    </>
  );
}
